import React from 'react'
import Link from 'next/link'
import Container from '../foundations/Container'
import Action from '../primitives/Action'
import ProcessStrip from './ProcessStrip'
import SeoHero from './SeoHero'
import styles from './ServiceHero.module.scss'

const ServiceHero = ({
  breadcrumbs,
  density = 'standard',
  eyebrow,
  title,
  description,
  image,
  imageAlt,
  primaryAction,
  processLabel,
  secondaryAction,
  stackActionsOnMobile = false,
  steps,
  tertiaryAction
}) => (
  <SeoHero
    className={`${styles.hero} ${density === 'compact' ? styles.heroCompact : ''}`.trim()}
    data-msr-service-hero='true'
    media={{
      picture: image?.picture,
      src: image?.src || image,
      alt: imageAlt,
      ratio: '21 / 9',
      objectPosition: image?.position || 'center'
    }}
    mediaLayerClassName={styles.mediaLayer}
    scrimClassName={styles.scrim}
  >

    <Container className={styles.content}>
      <div className={styles.copy}>
        {breadcrumbs?.length > 0 && (
          <nav className={styles.breadcrumbs} aria-label='Breadcrumb'>
            <ol>
              {breadcrumbs.map((item, index) => {
                const isCurrent = index === breadcrumbs.length - 1

                return (
                  <li key={`${item.label}-${item.href || index}`}>
                    {item.href && !isCurrent ? (
                      <Link href={item.href} legacyBehavior><a>{item.label}</a></Link>
                    ) : (
                      <span aria-current={isCurrent ? 'page' : undefined}>{item.label}</span>
                    )}
                  </li>
                )
              })}
            </ol>
          </nav>
        )}
        {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
        <h1>{title}</h1>
        <p>{description}</p>
        <div className={`${styles.actions} ${stackActionsOnMobile ? styles.actionsStackedMobile : ''}`.trim()}>
          {primaryAction && (
            <Action
              dataConversionChannel={primaryAction.channel}
              dataConversionKey={primaryAction.conversionKey}
              dataConversionLocation='hero'
              dataConversionSalesPath={primaryAction.salesPath}
              external={primaryAction.external}
              focusTargetOnNavigate={primaryAction.focusTargetOnNavigate}
              href={primaryAction.href}
              icon={primaryAction.icon}
              onClick={primaryAction.onClick}
              size='large'
            >
              {primaryAction.label}
            </Action>
          )}
          {secondaryAction && (
            <Action
              dataConversionChannel={secondaryAction.channel}
              dataConversionKey={secondaryAction.conversionKey}
              dataConversionLocation='hero'
              dataConversionSalesPath={secondaryAction.salesPath}
              external={secondaryAction.external}
              focusTargetOnNavigate={secondaryAction.focusTargetOnNavigate}
              href={secondaryAction.href}
              icon={secondaryAction.icon}
              onClick={secondaryAction.onClick}
              variant='dark'
              size='large'
            >
              {secondaryAction.label}
            </Action>
          )}
        </div>
        {tertiaryAction && (
          <Action
            className={styles.tertiaryAction}
            dataConversionChannel={tertiaryAction.channel}
            dataConversionKey={tertiaryAction.conversionKey}
            dataConversionLocation='hero'
            dataConversionSalesPath={tertiaryAction.salesPath}
            external={tertiaryAction.external}
            href={tertiaryAction.href}
            icon={tertiaryAction.icon}
            onClick={tertiaryAction.onClick}
            variant='plain'
          >
            {tertiaryAction.label}
          </Action>
        )}
      </div>
    </Container>

    {steps?.length > 0 && (
      <div className={styles.process}>
        <Container>
          <ProcessStrip ariaLabel={processLabel} steps={steps} />
        </Container>
      </div>
    )}
  </SeoHero>
)

export default ServiceHero
